$(function () {
	if ($('.jq_counter').length) {
		var counterObserver= new IntersectionObserver(function(items, self) {
			$.each(items, function(i, item) {
				if (item.isIntersecting) {
					var $counter = $(item.target);

					$('.jq_counter_number', $counter).each(function() {
						var $number = $(this);

						if ($number.text() === '' || typeof $number.data('end') === 'undefined') return;

						$({ Counter: parseInt($number.text()) }).animate(
							{
								Counter: parseInt($number.data('end'))
							},
							{
								duration: 1000,
								easing: 'swing',
								step: function (curValue) {
									$number.text(Math.ceil(curValue));
								}
							}
						);
					});

					self.unobserve(item.target);
				}
			});
		}, {
			rootMargin: '-20% 0%'
		});

		$('.jq_counter').each(function() {
			var $counter = $(this);
			var $number = $counter.find('.jq_counter_number');

			if ($number.length == 0) return;

			var end = $number.text();
			var start = Math.round(end * .25);

			$number.text(start).data('end', end);

			counterObserver.observe(this);
		});
	}
});
